import React from 'react';
import { motion } from 'framer-motion';

const LEVEL_LABELS = {
  1: 'Seedling', 2: 'Aware', 3: 'Roamer', 4: 'Storied',
  5: 'Bonded', 6: 'Resonant', 7: 'Mythic', 8: 'Ancestral',
};
const LEVEL_COLORS = {
  1: '#7a7a7a', 2: '#00f0ff', 3: '#ccff00', 4: '#ff007f',
  5: '#ffd700', 6: '#00ffc8', 7: '#9b5cff', 8: '#fff0a0',
};

/**
 * Bubble level badge — a colored chip that pulses softly at L5+.
 * Pass `size="lg"` for the detail page; default is for inline cards.
 */
const LevelBadge = ({ bubble, size = 'sm', showName = true }) => {
  const lvl = bubble?.level || 1;
  const color = bubble?.level_color || LEVEL_COLORS[lvl];
  const name = bubble?.level_name || LEVEL_LABELS[lvl];
  const pulses = lvl >= 5;
  const cls = size === 'lg'
    ? 'text-xs px-3 py-1 gap-2'
    : 'text-[10px] px-2 py-0.5 gap-1.5';
  return (
    <motion.span
      data-testid={`level-badge-${bubble?.id || 'none'}`}
      animate={pulses ? { boxShadow: [`0 0 0px ${color}`, `0 0 16px ${color}`, `0 0 0px ${color}`] } : {}}
      transition={pulses ? { duration: 2.5, repeat: Infinity } : {}}
      className={`inline-flex items-center uppercase tracking-widest font-bold rounded-full border ${cls}`}
      style={{ color, borderColor: color + '66' }}
    >
      <span className="font-mono">L{lvl}</span>
      {showName && <span>{name}</span>}
    </motion.span>
  );
};

export default LevelBadge;
